import axios from 'axios'
import util from '../Utils/util';

const axiosInstance =  axios.create({
    baseURL: "https://leadfuzionlists.com/crm_apis/v1/",
    // baseURL: "http://192.168.1.3:8000/crm_apis/v1/",    
    headers:{
        ContentType: 'application/json'
    }
})


axiosInstance.interceptors.request.use(
    (config) => {
        if (util.isLogged()) {
            config.headers.Authorization = 'token ' + util.getToken();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance